module.exports = __webpack_public_path__ + "static/media/N4.f0ad196d.jpg";